import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

// Components
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import InputField from "../../Shared/inputField/inputField";

// Styles
import Styles from "../../Shared/sharedStyles.module.scss";
import dropDownStyles from "../../../../../Shared/dropDownStyles";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

// Constants
import { days, months } from "../../../../../constants/data";

// Functions
import {
  validCustomerFileNumber,
  validNameCheck,
} from "../../../../../utils/validation";
import { getYears } from "../../../../../utils/getYears";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function PassportAdvanceServicePopup({ handleResponse, name }: any) {
  const dateRef = useRef<any>(null);
  const monthRef = useRef<any>(null);
  const yearRef = useRef<any>(null);

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const nameMatchRef = useRef<any>("");
  const [isNameMatchEnabled, setIsNameMatchEnabled] = useState(false);

  const errorObject = {
    customerFileNumberError: false,
    consentError: false,
    dobDayError: false,
    dobMonthError: false,
    dobYearError: false,
    nameToMatchError: false,
  };
  const yearOptions = getYears(1950);
  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const customerFileNumberRef = useRef<any>("");

  useEffect(() => {
    if (isNameMatchEnabled) {
      setIsDisabled(true);
    }
    if (!isNameMatchEnabled) {
      if (customerFileNumberRef.current.value && year && day && month) {
        setIsDisabled(false);
      }
    }
  }, [isNameMatchEnabled]);

  useEffect(() => {
    if (
      customerFileNumberRef.current.value &&
      year &&
      day &&
      month &&
      !isNameMatchEnabled
    ) {
      setIsDisabled(false);
    }
  }, [customerFileNumberRef, year, day, month]);

  useEffect(() => {
    if (isNameMatchEnabled) {
      if (
        customerFileNumberRef.current.value &&
        year &&
        day &&
        month &&
        nameMatchRef.current.value
      ) {
        setIsDisabled(false);
      }
    }
  }, [customerFileNumberRef, year, day, month, isNameMatchEnabled]);

  function isValid() {
    setError({ ...errorObject });
    const customerFileNumber = customerFileNumberRef.current.value
      .trim()
      .toUpperCase();
    if (validCustomerFileNumber(customerFileNumber) && day && month && year) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    if (!validCustomerFileNumber(customerFileNumber)) {
      setError(() => ({
        ...error,
        customerFileNumberError: true,
      }));
    }
    return setIsDisabled(true);
  }

  function isValidNameMatch() {
    setError({ ...errorObject });
    const customerFileNumber = customerFileNumberRef.current.value
      .trim()
      .toUpperCase();
    if (
      validCustomerFileNumber(customerFileNumber) &&
      validNameCheck(nameMatchRef.current.value) &&
      day &&
      month &&
      year
    ) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    if (!validCustomerFileNumber(customerFileNumber)) {
      setError(() => ({
        ...error,
        customerFileNumberError: true,
      }));
    }
    if (!validNameCheck(nameMatchRef.current.value)) {
      setError(() => ({
        ...error,
        nameToMatchError: true,
      }));
    }
    return setIsDisabled(true);
  }

  function handleCheck() {
    const customerFileNumber =
      customerFileNumberRef.current.value.toUpperCase();
    const consent = isChecked === true ? "Y" : "N";
    const dob = `${day}-${month}-${year}`;
    if (isNameMatchEnabled && nameMatchRef.current.value === "") {
      setError(() => ({
        ...error,
        nameToMatchError: true,
      }));
      return setIsDisabled(true);
    }
    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    if (nameMatchRef && nameMatchRef.current && nameMatchRef.current.value) {
      const nameToMatch = nameMatchRef.current.value;
      handleResponse(
        { customerFileNumber, nameToMatch, dob, consent },
        setLoading
      );
    } else if (!isNameMatchEnabled) {
      handleResponse({ customerFileNumber, dob, consent }, setLoading);
    }
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              Customer File Number
            </label>
            <InputField
              id={IdsGenerator({
                prefix: "passport advance popup",
                id: "change",
                suffix: "customer file number",
              })}
              onChange={isValid}
              minLength={12}
              maxLength={15}
              inputRef={customerFileNumberRef}
              isError={error.customerFileNumberError}
              purpose="forPassport"
            />
            {error.customerFileNumberError && (
              <ErrorMessage>
                Please enter a valid Customer file number
              </ErrorMessage>
            )}
          </div>

          <label className={`${Styles.label}`}>DOB*</label>
          <div className="d-flex mr-1">
            <div className="mr-2 d-flex">
              <div className="d-flex flex-column">
                <Select
                  id={IdsGenerator({
                    prefix: "passport advance popup",
                    id: "select",
                    suffix: "date",
                  })}
                  ref={dateRef}
                  onChange={(e: any) => setDay(e.value)}
                  options={days}
                  styles={
                    !error.dobDayError
                      ? dropDownStyles.customStylesForDays
                      : dropDownStyles.customStylesForDaysError
                  }
                  placeholder="DD"
                />
              </div>
              <div className="ml-2 d-flex flex-column">
                <Select
                  id={IdsGenerator({
                    prefix: "passport advance popup",
                    id: "select",
                    suffix: "month",
                  })}
                  onChange={(e: any) => setMonth(e.value)}
                  ref={monthRef}
                  options={months}
                  styles={
                    !error.dobMonthError
                      ? dropDownStyles.customStylesForMonths
                      : dropDownStyles.customStylesForMonthsError
                  }
                  placeholder="MMM"
                />
              </div>
              <div className="ml-2 d-flex flex-column">
                <Select
                  id={IdsGenerator({
                    prefix: "passport advance popup",
                    id: "select",
                    suffix: "year",
                  })}
                  onChange={(e: any) => setYear(e.value)}
                  ref={yearRef}
                  placeholder="YYYY"
                  options={yearOptions}
                  styles={
                    !error.dobYearError
                      ? dropDownStyles.customStylesForYears
                      : dropDownStyles.customStylesForYearsError
                  }
                />
              </div>
            </div>
          </div>
          <div className="pl-4 pb-2 pt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: "passport advance popup",
                  id: "check",
                  suffix: "is name match required",
                })}
                data-testid={IdsGenerator({
                  prefix: "passport advance popup",
                  id: "check",
                  suffix: "is name match required",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsNameMatchEnabled(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                is name match required ?
              </p>
            </div>
          </div>
          {isNameMatchEnabled && (
            <div className="d-flex flex-column mb-4 ">
              <label className={`${Styles.label} flex-grow-1`}>
                Name To Match
              </label>
              <InputField
                id={IdsGenerator({
                  prefix: "passport advance popup",
                  id: "change",
                  suffix: "is name match",
                })}
                onChange={isValidNameMatch}
                inputRef={nameMatchRef}
                isError={error.nameToMatchError}
                purpose="forPassport"
                text="lowerCase"
              />
              {error.nameToMatchError && (
                <ErrorMessage>Please enter a valid Name</ErrorMessage>
              )}
            </div>
          )}

          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: "passport advance popup",
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: "passport advance popup",
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  isNameMatchEnabled ? isValidNameMatch() : isValid();
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: "passport advance popup",
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PassportAdvanceServicePopup;
